import React, {useState, useEffect} from 'react';
import {PlusOutlined} from '@ant-design/icons';
import styles from './tag.group.module.less';
import {Tag, Input, message} from 'antd';
import _ from 'lodash';
import PropTypes from 'prop-types';

export default function TagGroup({getTags, origin, disabled, btnText = '新增敏感词'}) {
    const [tags, setTags] = useState([]);
    const [inputVisible, setInputVisible] = useState(false);
    const [value, setValue] = useState(null);
    const [isRmove, setIsRmove] = useState(false);
    useEffect(() => {
        tags.length == 0 && !isRmove && setTags(origin);
    }, [tags]);

    function showInput() {
        setInputVisible(true);
    }

    function handleBlur() {
        console.log(value);
        if (_.isEmpty(value)) {
            message.error('不能为空');
            return;
        }
        const temp = [...tags, value];
        setTags(temp);
        getTags(temp);
        setInputVisible(false);
    }

    function handleConfirm() {
        if (_.isEmpty(value)) {
            message.error('不能为空');
            return;
        }
        const temp = [...tags, value];
        setTags(temp);
        getTags(temp);
        setInputVisible(false);
    }

    function handleChange(e) {
        setValue(e.target.value);
    }

    function close(tag) {
        setIsRmove(true);
        console.log(tag);
        const temp = [...tags].filter(item => item != tag);
        console.log(temp);
        setTags(temp);
        getTags(temp);
    }

    function renderAddButton() {
        return inputVisible ? (
            <Input
                type="text"
                size="small"
                onBlur={handleBlur}
                onPressEnter={handleConfirm}
                onChange={handleChange}
                className={styles.tagInput}
            />
        ) : (
            <Tag className="site-tag-plus" onClick={showInput}>
                <PlusOutlined /> {btnText}
            </Tag>
        );
    }

    return (
        <div className={styles.tagGroup}>
            {tags.map((tag, i) => (
                <Tag
                    key={tag}
                    closable={!disabled}
                    onClose={() => close(tag)}
                    className={styles.tag}
                >
                    {tag}
                </Tag>
            ))}
            {disabled || renderAddButton()}
        </div>
    );
}

TagGroup.propTypes = {
    getTags: PropTypes.func,
    origin: PropTypes.array,
    disabled: PropTypes.bool,
    btnText: PropTypes.string,
};
